"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SagittaFrontierServices = void 0;
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderItem_1 = require("../render/CardRenderItem");
const Size_1 = require("../render/Size");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const Tags_1 = require("../Tags");
class SagittaFrontierServices extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.SAGITTA_FRONTIER_SERVICES,
            startingMegaCredits: 31,
            metadata: {
                cardNumber: '??',
                description: 'You start with 31 M€. Increase your energy production 1 step and M€ production 2 steps. Draw a card with no tags.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(31).production((pb) => pb.energy(1).megacredits(2));
                    b.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.NONE);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect(undefined, (eb) => {
                            eb.emptyTag(1, Size_1.Size.SMALL).startEffect.megacredits(4);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.effect('When you play cards with no tags, including this, gain 4 M€. When you play cards with EXACTLY 1 TAG, gain 1 M€.', (eb) => {
                            eb.blankTag(1, Size_1.Size.SMALL).played.asterix().startEffect.megacredits(1);
                        });
                    });
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        this.onCorpCardPlayed(player, this);
        player.drawCard(1, { include: (card) => card.tags.length === 0 && card.cardType !== CardType_1.CardType.EVENT });
        return undefined;
    }
    onCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    onCorpCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    _onCardPlayed(player, card) {
        if (!player.isCorporation(this.name))
            return undefined;
        const game = player.game;
        const count = card.tags.length + (card.cardType === CardType_1.CardType.EVENT ? 1 : 0);
        const hasOnlyWildTags = card.tags.length > 0 && card.tags.every((tag) => tag === Tags_1.Tags.WILDCARD);
        if (count === 0 || hasOnlyWildTags) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                player.addResource(Resources_1.Resources.MEGACREDITS, 4);
                game.log('${0} gained 4 M€ for playing ${1} with no tags.', (b) => b.player(player).card(card));
                return undefined;
            }), DeferredAction_1.Priority.GAIN_RESOURCE_OR_PRODUCTION);
        }
        else if (count === 1) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                player.addResource(Resources_1.Resources.MEGACREDITS, 1);
                game.log('${0} gained 1 M€ for playing ${1} with exactly 1 tag.', (b) => b.player(player).card(card));
                return undefined;
            }), DeferredAction_1.Priority.GAIN_RESOURCE_OR_PRODUCTION);
        }
        return undefined;
    }
}
exports.SagittaFrontierServices = SagittaFrontierServices;
//# sourceMappingURL=SagittaFrontierServices.js.map